import React, { createElement, useEffect, useState } from "react";
import ListSubheader from "@mui/material/ListSubheader";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { primaryColor } from "assets/colors";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Avatar, Badge, Typography, styled } from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AssistantIcon from "@mui/icons-material/Assistant";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import DataObjectIcon from "@mui/icons-material/DataObject";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import Box from "@mui/material/Box";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import AddCardIcon from "@mui/icons-material/AddCard";
import ListIcon from "@mui/icons-material/List";
import CustomScrollbars from "util/CustomScrollbars";
import { getBadgesAction } from "redux/actions/GeneralActions";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import WalletIcon from "@mui/icons-material/Wallet";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";

const SidenavContent = () => {
  const { first_name, last_name } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();

  // const pathname = `${history.location.pathname}`;
  // useEffect(() => {
  //   const current = document.getElementById(pathname);
  //   current?.classList?.add("open");

  //   if (current?.classList?.contains("sub-menu"))
  //     current.parentElement.classList.add("open");
  // }, [pathname]);

  // State to track the currently open submenu
  const [openSubMenu, setOpenSubMenu] = useState(-1);

  const handleClickSubMenu = (index) => {
    // Toggle the submenu only if it's different from the currently open one
    setOpenSubMenu((prevIndex) => (prevIndex === index ? -1 : index));
  };

  return (
    <List
      sx={{ width: "100%", maxWidth: 360 }}
      component="nav"
      aria-labelledby="nested-list-subheader"
      subheader={
        <ListSubheader
          component="div"
          id="nested-list-subheader"
          sx={{ backgroundColor: "unset", color: "unset" }}
        >
          <Box sx={{ display: "flex", py: 3 }}>
            <Avatar
              src="https://via.placeholder.com/150x150"
              sx={{ width: 44, height: 44, mr: 2 }}
            />
            {first_name} {last_name}
          </Box>
        </ListSubheader>
      }
      // dense
    >
      {MenuList.map((item, index) => {
        let isSelected = item.content?.find(
          (item) => `/${item.to}` === location.pathname
        );
        return item.content ? (
          <CustomListItemWithSubMenu
            title={item.title}
            icon={item.icon}
            content={item.content}
            open={openSubMenu === index || isSelected} // Pass whether this submenu is open
            onClick={() => handleClickSubMenu(index)} // Pass the index
          />
        ) : (
          <CustomListItem
            title={item.title}
            icon={item.icon}
            onClick={() => {
              navigate(item.to);
              handleClickSubMenu(index);
            }}
            selected={
              openSubMenu === index || `/${item.to}` === location.pathname
            }
          />
        );
      })}
    </List>
  );
};

// export default SidenavContent;

const CustomListItemWithSubMenu = ({ title, icon, content, open, onClick }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // const [open, setOpen] = useState(true);

  // const handleClick = () => {
  //   setOpen(!open);
  // };

  return (
    <>
      <ListItemButton
        sx={{ color: open ? "#fff" : "inherit", px: 3, py: 0.25 }} // Set the color based on open state
        onClick={onClick}
      >
        <ListItemIcon sx={{ color: "inherit", minWidth: "auto", mr: 2 }}>
          {icon}
        </ListItemIcon>
        <ListItemText sx={{ color: "inherit" }} primary={title} />
        <ExpandLess
          sx={{
            color: "inherit",
            transform: open ? `rotate(180deg)` : "rotate(90deg)",
            transition: "ease-in-out .1s transform",
            marginRight: "auto",
          }}
        />
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div">
          {content.map((item) => (
            <ListItemButton
              onClick={() => navigate(item.to)}
              selected={location?.pathname === `/${item.to}`}
              sx={{
                pl: 5,
                "&.Mui-selected": {
                  backgroundColor: primaryColor,
                  color: "#fff",
                },
              }}
              dense
            >
              {/* <ListItemIcon>
                {item.icon && cloneElement(item.icon)}
              </ListItemIcon> */}
              <ListItemText primary={item.title} />
            </ListItemButton>
          ))}
        </List>
      </Collapse>
    </>
  );
};

const CustomListItem = ({ title, icon, onClick, selected }) => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  const location = useLocation();

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <>
      <ListItemButton
        sx={{ color: selected ? "#fff" : "inherit" }} // Set the color based on open state
        onClick={onClick}
      >
        <ListItemIcon sx={{ color: "inherit", pl: 2 }}>{icon}</ListItemIcon>
        <ListItemText sx={{ color: "inherit" }} primary={title} />
      </ListItemButton>
    </>
  );
};

export const MenuList = [
  {
    title: "Dashboard",
    icon: <DashboardIcon />,
    to: "dashboard",
  },
  {
    title: "Role",
    icon: <AccountBoxIcon />,
    content: [
      {
        title: "Add Role",
        to: "role/add",
      },
      {
        title: "Role List",
        to: "role/list",
      },
    ],
  },
  {
    title: "Agent",
    icon: <AssistantIcon />,
    content: [
      {
        title: "Add Agent",
        to: "agent/add",
      },
      {
        title: "Agent List",
        to: "agent/list",
      },
    ],
  },
  {
    title: "Config",
    icon: <ToggleOnIcon />,
    content: [
      {
        title: "Default Wallets",
        to: "config/default-wallets",
      },
      {
        title: "Default Fees",
        to: "config/default-fee",
      },
      {
        title: "Default Fees List",
        to: "config/default-fees",
      },
    ],
  },
  {
    title: "Logs",
    icon: <DataObjectIcon />,
    content: [
      {
        title: "Users log",
        to: "logs/users-log",
      },
      {
        title: "Pep Logs",
        to: "logs/pep-logs",
      },
    ],
  },
];

const item = {
  py: "2px",
  px: 3,
  color: "rgba(255, 255, 255, 0.7)",
  "&:hover, &:focus": {
    bgcolor: "rgba(255, 255, 255, 0.08)",
  },
};

const itemCategory = {
  boxShadow: "0 -1px 0 rgb(255,255,255,0.1) inset",
  py: 1.5,
  px: 3,
};

export default function Navigator(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [badges, setBadges] = useState({ user: {}, ticket: {}, card: {} });

  const approvedUsersCount = useSelector(
    (state) => state.customer.approvedUsers.count
  );
  const starterUsersCount = useSelector(
    (state) => state.customer.starterUsers.count
  );
  const pendingUsersCount = useSelector(
    (state) => state.customer.pendingUsers.count
  );

  const categories = [
    {
      id: "Wallet",
      children: [
        {
          id: "Wallets",
          to: "wallet/balances",
          icon: WalletIcon,
        },
        {
          id: "Transactions",
          to: "wallet/transactions",
          icon: ListIcon,
        },
      ],
    },
    {
      id: "Card",
      icon: CreditCardIcon,
      children: [
        {
          id: "Request New Virtual Card",
          to: "cards/request-virtual-card",
          icon: AddCardIcon,
        },
        {
          id: "Request New Physical Card",
          to: "cards/request-physical-card",
          icon: AddCardIcon,
        },
        {
          id: "Top up Card",
          to: "cards/top-up",
          icon: PointOfSaleIcon,
        },
        {
          id: "Physical Cards",
          to: "cards/physical-cards",
          icon: ListIcon,
        },
        {
          id: "Virtual Cards",
          to: "cards/virtual-cards",
          icon: ListIcon,
        },
        {
          id: "Add Card",
          to: "cards/add-card",
          icon: AddCardIcon,
        },
      ],
    },
  ];

  useEffect(() => {
    // This will run only once when the component mounts
    // dispatch(getBadgesAction({ setBadges }));
  }, [dispatch]);

  useEffect(() => {
    // This will run whenever approvedUsersCount, starterUsersCount, or pendingUsersCount changes
    // dispatch(getBadgesAction({ setBadges }));
  }, [approvedUsersCount, starterUsersCount, pendingUsersCount, dispatch]);

  const [openSubMenu, setOpenSubMenu] = useState(-1);

  const handleClickSubMenu = (index) => {
    // Toggle the submenu only if it's different from the currently open one
    setOpenSubMenu((prevIndex) => (prevIndex === index ? -1 : index));
  };

  return (
    <CustomScrollbars className=" scrollbar">
      <List disablePadding>
        {categories.map(({ id, children }) => (
          <Box key={id}>
            <ListItem sx={{ py: 2, px: 3 }}>
              <ListItemText sx={{ color: "#fff" }}>{id}</ListItemText>
            </ListItem>
            {children.map(
              ({ id: childId, icon, badge, active, to, permissions }) => (
                <>
                  <ListItem disablePadding>
                    <ListItemButton
                      selected={active}
                      sx={item}
                      onClick={() => navigate(to)}
                    >
                      <ListItemIcon
                        sx={{ color: "inherit", minWidth: "auto", mr: 2 }}
                      >
                        {icon && createElement(icon, { fontSize: "small" })}
                      </ListItemIcon>
                      <StyledBadge
                        badgeContent={badge}
                        color="error"
                        max={Infinity}
                      >
                        <ListItemText>{childId}</ListItemText>
                      </StyledBadge>
                    </ListItemButton>
                  </ListItem>
                </>
              )
            )}
            <Divider sx={{ mt: 1 }} />
          </Box>
        ))}
      </List>
    </CustomScrollbars>
  );
}

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: -20,
    top: 15,
    // border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}));
